<template>
	<div class="container">
		<h2 class="h2-title">
			<span>产品试用申请</span>
		</h2>
		<div class="type-wrap">
			<div class="typelist">
				<h3>名称</h3>
				<ul>
					<li :class="[nameIndex==-1?'active':'']" @click="toAll('name')">全部</li>
					<li @click="toChangeNav(item.id, index, 'name')" :class="[nameIndex==index?'active': '']" v-for="(item, index) in nameList">{{item.categoryName}}</li>
				</ul>
			</div>
			<div class="typelist">
				<h3>架构</h3>
				<ul>
					<li :class="[architectureIndex==-1?'active':'']" @click="toAll('bulid')">全部</li>
					<li @click="toChangeNav(item.id, index, 'bulid')" :class="[architectureIndex==index?'active': '']" v-for="(item, index) in architectureList">{{item.categoryName}}</li>
				</ul>
			</div>
		</div>
		<ul class="content-list" v-if="dataList.length >0">
			<li v-for="item in dataList">
				<div class="list-left">
					<div class="list-title">
						<h3>{{item.productTitle}}</h3>
					</div>
					<div class="list-desc">
						{{item.productContent}}
					</div>
					<div class="list-tips">
						<div class="down-list-file" @click="toFile(item)">
							<img src="@/assets/document_icon.png" />
							<span>说明文档</span>
						</div>
						<div class="down-list-file" @click="toFile(item)">
							<img src="@/assets/document_icon.png" />
							<span>完整性检验: {{item.integrityCheck}}</span>
						</div>
						<span class="list-time">上线时间：{{item.liveTime | datefmt('yyyy-MM-DD')}}</span>
					</div>
				</div>
				<a class="download" href="javascript:;" @click="toDown(item.productUrl)">下载</a>
			</li>
		</ul>
		<Empty v-else content="该分类下无数据"/>
		<div v-if="total>pageSize">
			<Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post, ajaxParam } from '@/units/request.js'
	import Pagination from '@/components/pagination'
	import Empty from '@/components/empty'
	export default {
		name: 'applyTry',
		components: {
			Pagination,
			Empty
		},
		data(){
			return {
				columnId: '78',
				productId: '',
				nameList: [],
				architectureList: [],
				productNameId: '',
				productArchitectureId: '',
				dataList: [],
				nameIndex: -1,
				architectureIndex: -1,
				total: 0,
				pageNum: 1,
				pageSize: 10,
				userId: ''
			}
		},
		created() {
			this.userId = localStorage.getItem('userId')||''
			let productId = this.$route.query.id
			this.productId = productId
			this.getNameList()
			this.getArchitectureList()
			this.getDataList()
		},
		methods: {
			//获取名称列表数据
			async getNameList() {
				let param = {
					columnId: this.columnId,
					productId: this.productId
				}
				ajaxParam(param)
				const res = await post('v1/product/nameList', qs.stringify(param))
				if (res.data.code == 200) {
					this.nameList = res.data.list
					console.log(this.nameList)
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取架构列表数据
			async getArchitectureList() {
				let param = {
					productId: this.productId
				}
				ajaxParam(param)
				const res = await post('v1/product/architectureList', qs.stringify(param))
				if (res.data.code == 200) {
					this.architectureList = res.data.list
					console.log(this.architectureList)
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取列表数据
			async getDataList() {
				let param = {
					productId: this.productId,
					productArchitectureId: this.productArchitectureId,
					productNameId: this.productNameId,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/product/trialList', qs.stringify(param))
				if (res.data.code == 200) {
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			pageChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getDataList()
			},
			toChangeNav(id, index, type){
				if(type=='name') {
					this.nameIndex = index
					this.productNameId = id
				} else if(type=='bulid'){
					this.architectureIndex = index
					this.productArchitectureId = id
				}
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			toAll(type){
				if(type=='name') {
					this.nameIndex = -1
					this.productNameId = ''
				} else if(type=='bulid'){
					this.architectureIndex = -1
					this.productArchitectureId = ''
				}
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			toDown(productUrl){
				// if(!this.userId){
				// 	this.$router.push({
				// 		path: '/login'
				// 	})
				// 	return
				// }
				window.open(productUrl)
			}
		}
	}
</script>

<style lang="less" scoped>
	.container{
		padding-bottom: 30px;
	}
	.h2-title {
		width: 31%;
		margin: 20px 0 30px;
		font-size: 40px;
		span {
			position: relative;
			display: inline-block;
			margin-bottom: 15px;
		}

		span:after {
			content: '';
			height: 2px;
			position: absolute;
			left: 0;
			background-color: #DE0515;
			width: 100%;
			display: inline-block;
			bottom: -14px;
		}
	}
	.typelist{
		display: flex;
		line-height: 26px;
		h3{
			width: 60px;
			font-size: 18px;
			line-height: 30px;
		}
		ul{
			flex: 1;
			display: flex;
			flex-wrap: wrap;
			li{
				height: 28px;
				margin-left: 25px;
				margin-bottom: 10px;
				padding: 0 12px;
				background: transparent;
				border: 1px solid transparent;
				border-radius: 16px;
				text-align: center;
				font-weight: 500;
				cursor: pointer;
				box-sizing: border-box;
			}
			li.active{
				border-color: var(--color-text-a);
			}
		}
	}
	.content-list{
		li{
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;
			padding: 18px 24px;
			background: #fff;
			border-radius: 10px;
			.list-title{
				position: relative;
				display: flex;
				align-items: center;
				margin-bottom: 9px;

				text-overflow: ellipsis;
				white-space: nowrap;
				word-break: break-all;
				word-wrap: break-word;
				span.list-btn{
					display: inline-block;
					padding: 1px 8px;
					margin-right: 7px;
					font-size: 12px;
					border-radius: 3px;
					background-color: #fff;
					border: 1px solid #1075e7;
					color: #1075e7;
					user-select: none;
					cursor: pointer;
					text-align: center;
					line-height: 18px;
					position: absolute;
					left: 0;
					top: 2px;
				}
				h3{
					overflow: hidden;
					font-size: 18px;
					line-height: 26px;
					white-space: normal;
				}
			}
			.list-left{
				flex: 1;
			}
			.list-desc{
				margin-bottom: 12px;
				color: #404040;
				text-align: justify;
				line-height: 18px;
				font-size: 12px;
			}
			.list-tips{
				display: flex;
				font-size: 12px;
				.down-list-file{
					display: flex;
					align-items: center;
					margin-right: 18px;
					cursor: pointer;
					img{
						width: 16px;
						height: 16px;
						margin-right: 2px;
					}
					span {
						color: #1075e7;
					}
				}
				.list-time{
					margin-left: 18px;
					color: #768096;
				}
			}
			.download{
				width: 100px;
				height: 32px;
				margin-left: 30px;
				border: 1px solid #1075e7;
				border-radius: 5px;
				color: #1075e7;
				line-height: 32px;
				text-align: center;
				cursor: pointer;
			}
		}
		li:hover{
			position: relative;
			box-shadow: 0 2px 8px 0 rgba(34, 123, 255, .36);
			border-radius: 6px;
			z-index: 1
		}
	}
</style>
